import React, { useState } from "react";
import dayjs from "dayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setDialog, setLoading } from "slices/appSlice";
import Api from "api";

const GlobalBreakFixDialog = ({ open, onClose, policyKey }) => {
  const dispatch = useDispatch();
  const [effectiveDate, setEffectiveDate] = useState(null);

  const handleOk = async () => {
    if (!effectiveDate) {
      dispatch(setDialog({ message: "Effective Date is required." }));
      return;
    }

    dispatch(setLoading(true));
    try {
      await Api.policyEnforcementGrid.applyGlobalBreakFix(
        policyKey,
        dayjs(effectiveDate).format("YYYY-MM-DD")
      );
      dispatch(
        setDialog({
          message:
            "Global Break Fix has been applied to all health plans that adopted this policy.",
        })
      );
      onClose && onClose(true);
    } catch (error) {
      dispatch(
        setDialog({
          message: error?.response?.data?.errors || error.message,
          title: error?.code ? `${error.code} :: ${error.message}` : "Error",
        })
      );
      onClose && onClose(false);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose && onClose(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>Global Break Fix</DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography>
            Are you sure you want to apply this break fix to all health plans
            that have adopted this policy?
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              Effective Date
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                value={effectiveDate ? dayjs(effectiveDate) : null}
                onChange={(value) => setEffectiveDate(value)}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => onClose && onClose(false)} color="primary">
          <strong>CANCEL</strong>
        </Button>
        <Button
          onClick={handleOk}
          color="primary"
          autoFocus
          disabled={!effectiveDate}
        >
          <strong>OK</strong>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalBreakFixDialog;
